module.exports = __webpack_public_path__ + "media/images/Branding/HW Mark 1 square-453bcb412497cef10049493e208832bc.png";